<!-- eslint-disable vue/singleline-html-element-content-newline vue/multiline-html-element-content-newline -->
<template>
  <div class="messageContainer">
    <h3>{{ $t('views.redirect.title') }}</h3>

    <div v-if="isChrome()" class="messageContent">
      <h4>
        {{ $t('views.redirect.description') }}
      </h4>
      <h4 style="margin-top: 0px">
        {{ $t('views.redirect.download') }}
        <a
          href="https://chrome.google.com/webstore/detail/apeajlekggjikmfkmbdglalpdlampjoa"
          target="_blank"
        >Chrome Web Store</a>.
      </h4>
    </div>
    <div v-else class="messageContent">
      <h4>{{ $t('views.redirect.browserNotSupported') }}</h4>
      <h4>{{ $t('views.redirect.install') }}</h4>
    </div>
    <h4 style="margin-top: 20px">
      <a :href="redirectUrl">
        {{ $t('views.redirect.clickHere') }}
      </a>
      <span>{{ $t('views.redirect.redirect', { timer }) }}</span>
    </h4>
  </div>
</template>

<script>
import { isChrome } from '../tools/browserUtils';

export default {
  name: 'Redirect',
  data() {
    return {
      timer: 15,
    };
  },
  created() {
    setTimeout(this.decreaseTimerOrRedirect, 1000);
  },
  methods: {
    isChrome() {
      return isChrome();
    },
    decreaseTimerOrRedirect() {
      if (--this.timer === 0) {
        console.log('go go window open to: ', this.redirectUrl);
        window.open(this.redirectUrl, '_self');
      } else {
        setTimeout(this.decreaseTimerOrRedirect, 1000);
      }
    },
  },
  computed: {
    redirectUrl() {
      return this.$router.currentRoute.query.redirectUrl;
    },
  },
};
</script>

<style scoped>
.messageContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  font-size: 18px;
  line-height: 30px;
  font-weight: 100;
}

h4 {
  font-weight: 400;
}

.messageContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 20px;
}
</style>
